import { useContext } from "react";
import { GlobalOptionsContext } from "../contexts/GlobalOptionsContext";

export const useGlobalOptions = () => {
  const context = useContext(GlobalOptionsContext);
  if (context === undefined) {
    throw new Error("useGlobalOptions must be used within a GlobalOptionsProvider");
  }
  return context;
}; 